<template>
  <v-container text-xs-center fill-height>
    <v-snackbar
      :timeout="60000"
      :top="true"
      v-model="showRedirect"
      color="success"
    >
      <span>Zapisałem!</span>
      <v-btn dark flat @click.native="redirectToMainView">Przejdź dalej</v-btn>

    </v-snackbar>
    <v-layout row wrap align-center>

      <v-flex xs12>

        <v-card class="mx-auto" mx-auto>
          <v-card-title>
            <h1 class="headline">Personalizacja</h1>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>

              <v-flex xs12>
                <v-text-field
                  label="Twoja aktualna waga"
                  v-model="myWeightInput"
                  type="number"
                  min="0"
                  max="100"
                  :disabled="showRedirect"
                  :rules="[() => errorText==false || errorText]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="Wzmożony wysiłek"
                  :hint="((settings.sport)?'+200ml':'-200ml')"
                  v-model="settings.sport"
                  :disabled="showRedirect"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="Słoneczna pogoda"
                  :hint="((settings.sunny)?'+200ml':'-200ml')"
                  v-model="settings.sunny"
                  :disabled="showRedirect"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <small class="grey--text">Każdy kilogram masy ciała, wymaga wypicia 40ml płynu dziennie.</small>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-title>
            <h1 class="headline">Ustawienia</h1>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox
                  label="Skracaj listę wypitych napojów"
                  hint="Po zaznaczeniu, lista dzisiejszych napojów będzie skracana do 4 ostatnich."
                  persistent-hint
                  v-model="settings.lessHistory"
                  :disabled="showRedirect"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" flat @click="redirectToMainView" v-show="!showRedirect" >Anuluj</v-btn>
            <v-btn color="green darken-1" flat @click="setWeight(myWeightInput)" v-show="!showRedirect">Zapisz</v-btn>
            <v-btn color="green darken-1" flat @click="redirectToMainView" v-show="showRedirect">Przejdź dalej</v-btn>
          </v-card-actions>
        </v-card>
        <small class="grey--text">wersja 1.3</small>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'setWeight',
    // props: ['myWeight'],
    data() {
      return {

        myWeightInput: null,
        settings: {
          myWeight: null,
          sport: false,
          sunny: false,
          lessHistory: true,
        },
        errorText: false,
        showRedirect: false
      }
    },
    mounted() {

      if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
      // if (localStorage.getItem('sport')) this.sport = JSON.parse(localStorage.getItem('sport'));
      // if (localStorage.getItem('sunny')) this.sunny = JSON.parse(localStorage.getItem('sunny'));
      this.myWeightInput = this.settings.myWeight;
      console.log("myWeight: ", this.settings.myWeight, this.myWeightInput);
    },
    watch: {
      settings: {
        handler() {
          console.log('settings changed!');
          localStorage.setItem('settings', JSON.stringify(this.settings));
        },
        deep: true,
      },
      // sport: {
      //   handler() {
      //     console.log('sport changed!');
      //     localStorage.setItem('sport', JSON.stringify(this.sport));
      //   },
      //   deep: true,
      // },
      // sunny: {
      //   handler() {
      //     console.log('sunny changed!');
      //     localStorage.setItem('sunny', JSON.stringify(this.sunny));
      //   },
      //   deep: true,
      // }
    },
    methods: {
      setWeight(weight) {
        if (weight > 0 && weight < 400) {
          this.settings.myWeight = weight;
          this.errorText = false;
          this.showRedirect = true;

        } else {
          this.errorText = "Waga nie może być mniejsza niż 0kg i większa niż 400kg"
        }
      },
      redirectToMainView() {
        this.$router.push({name: 'mainView'});

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/setWeight.vue